import React from "react"
import ImageGallery from "react-image-gallery"

function ImagesGallery(props) {
    return (
        <ImageGallery
            items={props.images}
            originalHeight={props.height}
            useBrowserFullscreen={false}
            showFullscreenButton={false}
            startIndex={props.startIndex}
            showPlayButton={false}
        />
    )
}

export default ImagesGallery
